import { render } from "./ConfPage.vue?vue&type=template&id=64fa8995&scoped=true"
import script from "./ConfPage.vue?vue&type=script&lang=js"
export * from "./ConfPage.vue?vue&type=script&lang=js"

import "./ConfPage.vue?vue&type=style&index=0&id=64fa8995&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fa8995"]])

export default __exports__